import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "maintain-dialog-content"
};
import { ref, watch } from 'vue';
import MaintainCluster from './MaintainCluster.vue';
import MaintainZone from './MaintainZone.vue';
import MaintainServer from './MaintainServer.vue';
import DialogHeader from '@/components/dialog-header/index.vue';
import { storeToRefs } from 'pinia';
import { useMaintainStore } from '@/store/maintain';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const maintainStore = useMaintainStore();
    const {
      id,
      level,
      isShowMaintainDialog
    } = storeToRefs(maintainStore);
    const activeName = ref(level.value);
    const maintainedId = ref('0');
    watch(() => isShowMaintainDialog.value, () => {
      if (isShowMaintainDialog.value) {
        activeName.value = level.value;
        maintainedId.value = id.value;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(isShowMaintainDialog),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isShowMaintainDialog) ? isShowMaintainDialog.value = $event : null),
        "show-close": false,
        width: "80%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "Maintain/Recover",
          "guide-link": "aaa"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [_unref(level) === 'Cluster' ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: "Maintain/Recover Cluster",
            name: "Cluster"
          }, {
            default: _withCtx(() => [_createVNode(MaintainCluster, {
              "maintained-id": maintainedId.value
            }, null, 8, ["maintained-id"])]),
            _: 1
          })) : _createCommentVNode("", true), ['Cluster', 'Zone'].includes(_unref(level)) ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: "Maintain Zone",
            name: "Zone"
          }, {
            default: _withCtx(() => [_createVNode(MaintainZone, {
              "maintained-id": maintainedId.value,
              "maintained-level": _unref(level)
            }, null, 8, ["maintained-id", "maintained-level"])]),
            _: 1
          })) : _createCommentVNode("", true), ['Cluster', 'Server'].includes(_unref(level)) ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            label: "Maintain Check",
            name: "Server"
          }, {
            default: _withCtx(() => [_createVNode(MaintainServer, {
              "maintained-id": maintainedId.value,
              "maintained-level": _unref(level)
            }, null, 8, ["maintained-id", "maintained-level"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});